export default __webpack_public_path__ + "static/media/add_icon.8abea30b.svg";